import { PreLoginKcRealmVO } from '@repo/types'
import { KC_INFO, UPDATE_USER, store } from '@web/modules/core/utils'
import { useFormContext } from 'react-hook-form'
import { PreLoginFormValues } from './usePreLoginForm'

export const useStageRealm = () => {
  const form = useFormContext<PreLoginFormValues>()
  const { trigger: triggerValidationOn } = form

  const realmFormKey = 'realm'

  let isValid = true

  const redirect = async (realm: PreLoginKcRealmVO) => {
    isValid = await triggerValidationOn(realmFormKey)

    if (!isValid) {
      return
    }

    store(KC_INFO, realm)
    store(UPDATE_USER, true)

    window.location.assign(realm.loginUrl)
  }

  return {
    form,
    redirect
  }
}
